import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { getAdminSettingsToolPath } from '../admin-tool-registry/admin-tool.registry';
import {
  AdminStatsSectionNav,
  AdminStatsSectionNavItem,
} from '../admin-stats-section-nav/admin-stats-section-nav';

@Component({
  selector: 'admin-tool-creator-stats',
  imports: [RouterOutlet, AdminStatsSectionNav],
  templateUrl: './creator-stats.html',
  host: { class: 'block h-full w-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreatorStats {
  readonly navItems: AdminStatsSectionNavItem[] = [
    { label: 'Dashboard', route: `${getAdminSettingsToolPath('creator-stats')}/dashboard` },
    { label: 'List', route: `${getAdminSettingsToolPath('creator-stats')}/list` },
  ];
}
